module.exports = __webpack_public_path__ + "static/people_mobile-986109fe5f558f77fad5f463ae1ed5f2.png";